import { render, staticRenderFns } from "./querySearch.vue?vue&type=template&id=afb5af06&scoped=true"
import script from "./querySearch.vue?vue&type=script&lang=js"
export * from "./querySearch.vue?vue&type=script&lang=js"
import style0 from "./querySearch.vue?vue&type=style&index=0&id=afb5af06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5af06",
  null
  
)

export default component.exports